import logo from './logo.svg';
import './App.css';
import { Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';
import Home from './components/Home';
import Header from './components/Header';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "aos/dist/aos.css";
import Footer from './components/Footer';
import Register from './components/Register';
import Home1 from './components/Dashboard/Home';
import Dashboard from './components/Dashboard/Dashboard';
import Images from './components/Dashboard/Images';
import Notifications from './components/Dashboard/Notifications';
import Links from './components/Dashboard/Links';
import Login from './components/Login/login';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AdminHome from './components/Dashboard/AdminHome';
import Renewal from './components/Dashboard/Renewal';

function AppContent() {

  const location = useLocation();
  const hideLayout = ["/dashboard", "/dashboard/home", "/dashboard/home-admin", "/dashboard/register-user", "/dashboard/bulk-register", 
    "/dashboard/bulk-renew"].includes(location.pathname);
  const hideFooter = ["/dashboard", "/dashboard/home", "/dashboard/home-admin", "/dashboard/register-user", "/dashboard/bulk-register",
     "/dashboard/bulk-renew", "/login"].includes(location.pathname);
  return (
    <>

      {!hideLayout && <Header />}
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/register' element={<Register />} />
        <Route path='/login' element={<Login />} />
        <Route path="dashboard" element={<Dashboard />}>
          <Route path="home" element={<Home1 />} />
          <Route path="register-user" element={<Images />} />
          <Route path="bulk-register" element={<Notifications />} />
          <Route path="bulk-renew" element={<Renewal />} />
          <Route path="home-admin" element={<AdminHome />} />
        </Route>
      </Routes>

      {!hideFooter && <Footer />}

      <ToastContainer position="top-center" hideProgressBar="true" autoClose={3000} />
    </>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}
export default App;
